import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import "./modalstyle.scss";
import { showToast } from "../../utils/utils";
import { showToastType } from "../../utils/constants/appConstants";
import { buttonName, roleMange } from "../../locales/en";
import { limitedAccessModelThunk } from "../../redux/roleManagementSlice";
import { useDispatch } from "react-redux";
import CommonModal from "./CommonModal";
import ErrorBoundary from "../error-boundary";
import ModalFallback from "../error-boundary/fallback/ModalFallback";
const LimitedAccessModal = ({ isOpen, toggle, permissionId }) => {
  const [permissions, setPermissions] = useState([]);
  const [loading, setLoading] = useState(true);

  const dispatch = useDispatch();

  const loadUsers = async (permissionId) => {
    try {
      setLoading(true);
      const response = await dispatch(
        limitedAccessModelThunk(Number(permissionId))
      ).unwrap();
      setPermissions(response.data.data);
    } catch (error) {
      showToast(error.message, showToastType.error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (permissionId) {
      loadUsers(permissionId);
    }
  }, [permissionId]);

  const handleClose = () => {
    toggle(false);
  };

  return (
    <CommonModal
      isOpen={isOpen}
      toggle={handleClose}
      title={
        <>
          {` ${roleMange?.limitedAccModal?.title1} ${permissionId} `}
          {` ${roleMange?.limitedAccModal?.title2} `}
        </>
      }
      modalClassName="modal-dialog modal-lg"
      bodyClassName="p-3"
      footerButtons={[
        {
          label: buttonName?.close,
          className: "btn btn-secondary",
          onClick: handleClose
        }
      ]}
    >
      <ErrorBoundary fallback={<ModalFallback />}>
        <div className="row">
          <div className="col-12">
            {loading ? (
              <div className="spinner-wrap bg-light">
                <div className="spinner-border custom-spinner-color" />
              </div>
            ) : (
              <ul className="permissions_content list-inline mb-0">
                {permissions.map((permission) => (
                  <li className="list-inline-item" key={permission.id}>
                    <span className="badge border border-dark text-dark rounded-pill mb-1">
                      {permission.description}
                    </span>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </ErrorBoundary>
    </CommonModal>
  );
};

LimitedAccessModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  permissionId: PropTypes.string.isRequired
};

export default LimitedAccessModal;
